export default function SummerLight() {
  return <div className="atmos-animation atmos-summer-light" aria-hidden="true" />;
}
